module.exports = __webpack_public_path__ + "static/media/LogoWirebitTransfer_Azul.aba5f46a.png";